import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import SpatialNavigationWrapper from 'components/navigation/SpatialNavigationWrapper';
import { StyledListContentWrapper, StyledListTitle } from './StyledComponents';
import { FocusableParent } from '../navigation';

const getNaturalNumber = (number) => (number > 0 ? number : 0);

class HorizontalList extends PureComponent {
  state = {
    focusedItemIndex: getNaturalNumber(this.props.defaultIndex),
  };

  componentDidMount() {
    const { defaultSection, defaultIndex, listId, items } = this.props;
    // Set focus to default element
    if (defaultSection && defaultIndex && items[defaultIndex]) {
      SpatialNavigationWrapper.focus(`#${listId}-item-${defaultIndex}`);
    }
  }

  onFocus = (index) => {
    const { onFocus, items } = this.props;
    this.setState({ focusedItemIndex: index });
    onFocus && onFocus(items[index], index);
  };

  onEnter = (index) => {
    const { onEnter, items } = this.props;
    onEnter && onEnter(items[index], index);
  };

  getStartRenderIndex() {
    const { renderSize } = this.props;
    const { focusedItemIndex = 0 } = this.state;
    return Math.max(focusedItemIndex - Math.floor((renderSize - 1) / 2), 0);
  }

  calculateOffset() {
    const { startScrollIndex, renderSize, items } = this.props;
    const { focusedItemIndex } = this.state;
    const { itemSize } = this.props;
    const index = Math.max(focusedItemIndex - this.getStartRenderIndex() - startScrollIndex, 0);
    return items.length >= renderSize / 2 ? index * itemSize : 0;
  }

  getRenderData() {
    const { items, renderSize } = this.props;
    const startIndex = this.getStartRenderIndex();
    return (items || []).slice(startIndex, startIndex + renderSize);
  }

  render() {
    const { onFocus, onEnter } = this;
    const {
      className,
      title,
      listId,
      config,
      sectionName,
      defaultSection,
      itemComponent,
      itemRender,
      onWheel,
    } = this.props;
    const { focusedItemIndex } = this.state;

    const ItemComponent = itemComponent;
    const data = this.getRenderData();
    const startRenderIndex = this.getStartRenderIndex();

    return (
      <FocusableParent
        className={className}
        id={listId}
        config={{ ...config, defaultElement: `#${listId}-item-0` }}
        sectionName={sectionName}
        defaultSection={defaultSection}
      >
        {title && <StyledListTitle>{title}</StyledListTitle>}
        <StyledListContentWrapper onWheel={onWheel} listOffset={this.calculateOffset()}>
          {data.map((item, i) => {
            const index = i + startRenderIndex;
            const props = {
              key: `${listId}-item-${index}`,
              id: `${listId}-item-${index}`,
              isActive: focusedItemIndex === index,
              onFocus,
              onEnter,
              index,
              item,
            };

            if (itemComponent) return <ItemComponent {...props} />;
            if (itemRender) return itemRender(props);
            return null;
          })}
        </StyledListContentWrapper>
      </FocusableParent>
    );
  }
}

HorizontalList.defaultProps = {
  defaultIndex: 0,
  startScrollIndex: 0,
  renderSize: 10,
};

HorizontalList.propTypes = {
  items: PropTypes.array.isRequired,
  itemSize: PropTypes.number.isRequired,
  listId: PropTypes.string.isRequired,
  sectionName: PropTypes.string.isRequired,
  onEnter: PropTypes.func,
  onFocus: PropTypes.func,
  itemComponent: PropTypes.elementType,
  itemRender: PropTypes.func,
  title: PropTypes.string,
  defaultSection: PropTypes.bool,
  renderSize: PropTypes.number,
  defaultIndex: PropTypes.number,
  startScrollIndex: PropTypes.number,
  config: PropTypes.object,
};

export default HorizontalList;
